import type { FC } from 'react';
import styles from './PlatformSection.module.css';

interface RequesterAvatarProps {
  isActive: boolean;
}

/* Customer avatar — an organization / building silhouette inside a soft
   circle. Three concentric "request" rings emanate upward only when
   `isActive` is true (stage 3: request being sent).
   "Org &amp; Personal" copy supports both customer types but visually
   prioritizes the org icon, since institutional customers are the
   primary persona. */
export const RequesterAvatar: FC<RequesterAvatarProps> = ({ isActive }) => (
  <div className={styles.avatar}>
    <svg viewBox="0 0 80 80" className={styles.avatarSvg} aria-hidden="true">
      {/* Outer halo */}
      <circle cx="40" cy="40" r="38" className={styles.avatarHalo} />
      {/* Building base */}
      <path d="M 18 64 L 18 36 L 30 36 L 30 64 Z" className={styles.avatarBuilding} />
      <path d="M 50 64 L 50 28 L 62 28 L 62 64 Z" className={styles.avatarBuilding} />
      {/* Building rooftops */}
      <rect x="34" y="30" width="2" height="6" className={styles.avatarBuilding} />
      <rect x="44" y="30" width="2" height="6" className={styles.avatarBuilding} />
      {/* Windows */}
      <rect x="21" y="42" width="6" height="6" className={styles.avatarWindow} />
      <rect x="21" y="52" width="6" height="6" className={styles.avatarWindow} />
      <rect x="53" y="34" width="6" height="6" className={styles.avatarWindow} />
      <rect x="53" y="44" width="6" height="6" className={styles.avatarWindow} />
      <rect x="53" y="54" width="6" height="6" className={styles.avatarWindow} />
      {/* Ground bar */}
      <rect x="14" y="64" width="52" height="3" className={styles.avatarGround} />
      {/* Request rings (only on stage 3) */}
      {isActive && (
        <>
          <circle cx="40" cy="32" r="18" className={styles.avatarRing1} />
          <circle cx="40" cy="32" r="26" className={styles.avatarRing2} />
          <circle cx="40" cy="32" r="34" className={styles.avatarRing3} />
        </>
      )}
    </svg>
  </div>
);
